/**
 * Template of the vacuum check form (ASSET_VACUUM_CHECK). The user downloads
 * it in the event's file step, fills it in and uploads the result there.
 *
 * It lives in the file service under `/file/auth/vacuum-check/` (same origin;
 * the dev server proxies `/file` to testing). That path answers 401 without the
 * user's JWT, so it is fetched through useAuthenticatedFileDownload — a .docx
 * can't be shown in a tab, so it is saved under its own name instead.
 */
const VACUUM_CHECK_TEMPLATE_FILE_NAME = 'Checklist Form VacuumCheck (EN).docx';

export const VACUUM_CHECK_TEMPLATE = {
    fileName: VACUUM_CHECK_TEMPLATE_FILE_NAME,
    url: `/file/auth/vacuum-check/${encodeURIComponent(VACUUM_CHECK_TEMPLATE_FILE_NAME)}`,
};
